import { render, staticRenderFns } from "./GallaryBooking.vue?vue&type=template&id=c6aa28ac"
import script from "./GallaryBooking.vue?vue&type=script&lang=js"
export * from "./GallaryBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports